import { createFileRoute } from '@tanstack/react-router'
import node, { type adminPageQuery } from '#gen/relay/adminPageQuery.graphql'
import { createRelayEnvironment } from '#lib/relay/relay-environment'
import { createRelayPreloader } from '#lib/relay/relay-preloader'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute('/admin')({
  staticData: { title: 'Instance admin' },
  async beforeLoad() {
    const relayEnvironment = createRelayEnvironment({})

    const preload = createRelayPreloader(relayEnvironment)

    return { relayEnvironment, preload }
  },
  async loader({ context }) {
    return context.preload<adminPageQuery>(node)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/admin/admin-page'),
    'AdminPage',
  ),
})
